export default __webpack_public_path__ + "static/rocket3d-83b1117788a6fb5a71a7d32b2ec58992.svg";